/* unplugin-vue-components disabled */import { render } from "./UserCertificate.vue?vue&type=template&id=1bc19ae6&ts=true"
import script from "./UserCertificate.vue?vue&type=script&lang=ts"
export * from "./UserCertificate.vue?vue&type=script&lang=ts"

import "./UserCertificate.vue?vue&type=style&index=0&id=1bc19ae6&lang=less"

import exportComponent from "/work/release/ug-fe-contest-student/node_modules/.pnpm/vue-loader@16.7.0_@vue+compiler-sfc@3.2.23_vue@3.2.23_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])